/* global u */

/**
* Polling inertaction
*
**/
export default function() {
  let vote = u('.js-poll-vote');
  let poll = u('.js-poll');

  vote.on('click', () => {
    poll.addClass('poll__voted');
  });
}
